import type { BreadcrumbItem } from "@/domains/navigation"
import { ManualClV2ManagePagesComplexBreadcrumbApplication } from "@/domains/navigation/components/complex-breadcrumb-applications/manual-cl-v2-manage-pages-complex-breadcrumb-application"
import { ManualClV2PositionComplexBreadcrumbApplication } from "@/domains/navigation/components/complex-breadcrumb-applications/manual-cl-v2-position-complex-breadcrumb-application"
import { CreateManualClV2LiquiditySubItem } from "@/domains/navigation/subitems/create-manualcl-v2-liquidity-subitem"
import {
  ManualClV2AllPoolsSubItem,
  ManualClV2MyPositionsSubItem,
} from "@/domains/navigation/subitems/manualcl-v2-liquidity-subitem"

export const MANUAL_CL_V2_BREADCRUMBS: BreadcrumbItem[] = [new ManualClV2AllPoolsSubItem()]

export const CREATE_MANUAL_CL_V2_BREADCRUMBS: BreadcrumbItem[] = [
  new ManualClV2AllPoolsSubItem(),
  new CreateManualClV2LiquiditySubItem(),
]

export const MANAGE_MANUAL_CL_V2_BREADCRUMBS: BreadcrumbItem[] = [
  new ManualClV2AllPoolsSubItem(),
  new ManualClV2MyPositionsSubItem(),
  ManualClV2PositionComplexBreadcrumbApplication,
  ManualClV2ManagePagesComplexBreadcrumbApplication,
]
